import React from "react";
import { StoreContext } from "./StoreContext";

export function useStore() {
  const store = React.useContext(StoreContext);
  return store;
}
